import { useUserAddresses, UserAddressGet } from "@/api/users"
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

interface UserAddressSelectProps {
  defaultValue?: string;
  value?: string;
  onSelect: (addressId: string) => void;
  onAddNew: () => void;
}

export default function UserAddressSelect({
  onSelect,
  defaultValue,
  value,
  onAddNew,
}: UserAddressSelectProps) {
  const { addresses } = useUserAddresses()

  return (
    <Select
      disabled={!addresses}
      onValueChange={onSelect}
      defaultValue={defaultValue}
      value={value}
    >
      <SelectTrigger>
        <SelectValue
          placeholder={!addresses ? "Loading..." : "Select address"}
        />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {addresses &&
            addresses.map((address: UserAddressGet) => (
              <SelectItem key={address.id} value={address.id}>
                {address.streetLine1}, {address.city}, {address.postalCode}
              </SelectItem>
            ))}
          <SelectItem value="new" onClick={onAddNew}>
            Add new address
          </SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}
